import fb from '@/firebaseConfig';
import axios from 'axios';

export const fetchMetadataFromUrl = async fetchURL => {
  console.log('start fetch metadata');
  //  url and data which will be used for axios to get the website metadata
  const fetchSourceGCFURL = fb.paths.function + 'fetchUrlMetadata';
  //const fetchSourceGCFURL = fb.paths.functionLocal + 'fetchUrlMetadata';
  const data = {
    url: fetchURL
  };
  let sourceData = {
    url: fetchURL
  };
  //only run in URL is not blank
  if (fetchURL !== '') {
    try {
      //if you fail to get the metadata just set metadata for url to the provided url
      const metadata = await axios.post(fetchSourceGCFURL, data);
      if (metadata.data) {
        sourceData = metadata.data;
      }
      console.log(metadata);
    } catch (error) {
      console.log(error);
      throw new Error('error fetching url data', error);
    }
    console.log('got url data!');
    console.log('sourceData', sourceData);
    return sourceData;
  } else {
    throw new Error('error: no fetch url');
  }
};
